module.exports = __webpack_public_path__ + "img/room8.edb9ef1c.gif";